import {
  Bot,
  Box,
  ChartColumnIncreasing,
  CircleMinus,
  CloudDownload,
  Filter,
  FlaskConical,
  Network,
  Search,
  Settings,
  Share2,
  TagIcon,
  Unplug,
  User,
  Users,
} from 'lucide-react';

import useUserRole from '@/hooks/domain/useUserRole';

import type { SettingSidebarMenuT, SettingTabItemObjT } from '../constants';

export const SETTING_TAB_KEYS = [
  'my-account',
  'members',
  'integration',
  'search',
  'tags',
  'charts',
  'product-info',
  'exclusion-analysis',
  'exclusion-importing',
  'export-history',
  'api',
  'slack-chatbot',
  'general',
  'labs',
] as const satisfies readonly SettingSidebarMenuT[];

const PERSONAL_PREFERENCE_TAB_KEYS = [
  'filter-visibility',
] as const satisfies readonly SettingSidebarMenuT[];

export const getPersonalPreferenceTabKeys = () =>
  PERSONAL_PREFERENCE_TAB_KEYS;

export const useSettingTabItems = () => {
  const { isEditor, isInnerMember } = useUserRole();

  const settingTabItems: SettingTabItemObjT = {
    'my-account': {
      key: 'my-account',
      text: 'My Account',
      Icon: <User />,
    },
    'filter-visibility': {
      key: 'filter-visibility',
      text: 'Filter visibility',
      Icon: <Filter />,
    },
    members: {
      key: 'members',
      hidden: () => !isEditor,
      text: 'Members',
      Icon: <Users />,
    },
    integration: {
      key: 'integration',
      hidden: () => !isEditor,
      text: 'Integration',
      Icon: <Share2 />,
    },
    search: {
      key: 'search',
      hidden: () => !isEditor,
      text: 'Search',
      Icon: <Search />,
    },
    taxonomy: {
      key: 'taxonomy',
      hidden: () => !isEditor,
      text: 'Taxonomy',
      Icon: <Network />,
    },
    tags: {
      key: 'tags',
      hidden: () => !isEditor,
      text: 'Tags',
      Icon: <TagIcon />,
    },
    charts: {
      key: 'charts',
      hidden: () => !isEditor,
      text: 'Charts',
      Icon: <ChartColumnIncreasing />,
    },
    'product-info': {
      key: 'product-info',
      hidden: () => !isEditor,
      text: 'Product Info',
      Icon: <Box />,
    },
    'exclusion-analysis': {
      key: 'exclusion-analysis',
      hidden: () => !isEditor,
      text: 'Exclusion: Analysis',
      Icon: <CircleMinus />,
    },
    'exclusion-importing': {
      key: 'exclusion-importing',
      hidden: () => !isEditor,
      text: 'Exclusion: Importing',
      Icon: <CircleMinus />,
    },
    'export-history': {
      key: 'export-history',
      hidden: () => !isEditor,
      text: 'Export history',
      Icon: <CloudDownload />,
    },
    api: {
      key: 'api',
      hidden: () => !isEditor,
      text: 'API',
      Icon: <Unplug />,
      isBeta: true,
    },
    'slack-chatbot': {
      key: 'slack-chatbot',
      hidden: () => !isEditor,
      text: 'Slack Chatbot',
      Icon: <Bot />,
      isBeta: true,
    },
    // appearance: {
    //   key: 'appearance',
    //   text: 'Appearance',
    //   Icon: <EyeOutlined />,
    // },
    general: {
      key: 'general',
      hidden: () => !isEditor,
      text: 'Workspace',
      Icon: <Settings />,
    },
    labs: {
      key: 'labs',
      hidden: () => !isInnerMember,
      text: 'Labs',
      Icon: <FlaskConical />,
    },
  };

  return settingTabItems;
};
